import { FitroomViewportContext } from './fitroomViewportContext';

const contexts: Map<string, FitroomViewportContext> = new Map<string, FitroomViewportContext>();

export const fitroomViewportModuleContext = (name = 'DEFAULT'): FitroomViewportContext => {
  // Return existing
  if (contexts.has(name)) {
    return contexts.get(name)!;
  }
  // Return new
  const context = new FitroomViewportContext();
  contexts.set(name, context);
  return context;
};

export const fitroomViewportModuleDisposeContext = (name = 'DEFAULT'): void => {
  if (!contexts.has(name)) {
    return;
  }
  // const context = new FitroomViewportContext();
  // contexts.dispose();
  contexts.delete(name);
};
